import { render, staticRenderFns } from "./TheBestTijuanaComponent.vue?vue&type=template&id=4c0a9639&scoped=true&"
import script from "./TheBestTijuanaComponent.vue?vue&type=script&lang=js&"
export * from "./TheBestTijuanaComponent.vue?vue&type=script&lang=js&"
import style0 from "./TheBestTijuanaComponent.vue?vue&type=style&index=0&id=4c0a9639&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a9639",
  null
  
)

export default component.exports